var address_fields = [
    {
        name: 'id',
    },
    {
        name: 'name',
    },
    {
        name: 'line1',
    },
    {
        name: 'line2',
    },
    {
        name: 'city',
    },
    {
        name: 'state',
    },
    {
        name: 'postal_code',
    },
    {
        name: 'skip_validation',
        def_value: false
    },
    {
        name: 'static',
        def_value: true,
        get: false
    }

];

var address = {
    fields: address_fields,
    states_list: [],
    references_list: [],
    setStatesList: function (list) {
        this.states_list = list;
    },
    setReferencesList: function (list) {
        this.references_list = list;
    },
    fill: function (address) {
        address_fields.forEach(function (field) {
            this[field.name](address[field.name] !== undefined ? address[field.name] : field.def_value);
        }, this);
    },
    clean: function () {
        address_fields.forEach(function (field) {
            this[field.name]('');
        }, this);
    },
    get: function () {
        return this.fields.map(function (field) {
            return this[field.name]
        }, this)
    },
    getData: function () {
        var obj = {};
        this.fields.forEach(function (field) {
            if (field.get === false) return;

            obj[field.name] = this[field.name]();
        }, this)  ;
        return obj;
    },
    getFieldsList: function () {
        return this.fields;
    }
};

module.exports = address;



//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/components/address_proto.js
// module id = 11
// module chunks = 0